var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement(
  "svg",
  _extends({ width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
  React.createElement(
    "defs",
    null,
    React.createElement("path", { d: "M18.098 15.784l3.438 3.438a1.605 1.605 0 1 1-2.27 2.27l-3.597-3.598c-3.267 1.909-7.502 1.487-10.27-1.282-3.3-3.3-3.266-8.686.076-12.028 3.343-3.343 8.728-3.377 12.029-.077 3.063 3.063 3.254 7.922.594 11.277zm-10.43-1.442c2.063 2.063 5.43 2.042 7.518-.047 2.09-2.09 2.111-5.455.048-7.518-2.063-2.063-5.428-2.042-7.518.048-2.089 2.089-2.11 5.455-.048 7.517z", id: "navbar-discover" })
  ),
  React.createElement("use", { fill: "#0500be", xlinkHref: "#navbar-discover", fillRule: "evenodd" })
));


// WEBPACK FOOTER //
// ./src/shared/components/NavBar/icons/Discover.svg